<template>
<loader v-bind="{ loading }">
  
  <div class="columns">
    <div class="column">
      <div class="box">
        <h5 class="title is-5">CWE-{{ cwe.number }}</h5>
        {{ cwe.description }}
      </div>
      <form>
        <h4 class="title is-6">False Positives</h4>
        <div class="columns">
          <div class="column">
            <text-input 
              classes="has-addons is-rounded"
              v-model="type.description"
              :error="$root.errorBag.description">
              Description
              <template #right>
                <submit-button :working="storingType" @submit="storeType">Add False Positive</submit-button>
              </template>
            </text-input>
          </div>
        </div>
      </form>

      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>False Positive</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="type in cwe.false_positive_types" :key="type.id">
            <td>{{ type.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</loader>  
</template>
<script>
import { mapGetters } from 'vuex'
import { storeCweFalsePositiveType } from '@/api/super'
import AssessmentBuilder from '@/views/assessors/Builder'

export default {

  components: {
    AssessmentBuilder,
  },
  
  data: () => ({
    loading: true,
    storingType: false,
    type: {
      description: '',
      cweId: ''
    }
  }),

  beforeCreate() {
    this.$store.dispatch('cwe/loadCwe', this.$route.params.cwe).then(() => {
      this.loading = false
    })
  },

  methods: {
    storeType() {
      this.storingType = true
      storeCweFalsePositiveType({
          ...this.type,
          cweId: this.cwe.id
        }, ({data}) => {
          this.$store.commit('cwe/addFalsePostiveType', data)
          this.type.description = ''
          this.$toast.success('False Positive Type Saved')
          this.storingType = false
      }, error => {
        this.storingType = false
      })
    }
  },

  computed: {
    ...mapGetters('cwe', [
      'cwe'
    ])
  }

}
</script>